export default __webpack_public_path__ + "static/media/vu.2e560acd.svg";